import { CommentQuoteIcon } from './CommentQuoteIcon';

/**
 * author: Michael Irigoyen
 * id 6A2BA297-7401-4727-B79F-8C8DD0F56FE7
 * name comment-quote
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-quote.svg
 * tags
 */
export const FeedbackIcon = CommentQuoteIcon;
export default FeedbackIcon